import gql from "graphql-tag";
export const LIST_TENANTS = gql`query ListTenants {
  tenants: listTenants {
    uuid
    title
    is_active
    kind
  }
}
`;